import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import {
  AlarmCommandEvent,
  AlarmDataOut,
  Client,
} from '../../../api/api-reference';
import { alertColors, getAlertColor } from '../alert-colors';

@Component({
  selector: 'app-event-information',
  standalone: true,
  imports: [TranslateModule, CommonModule, AngularSvgIconModule],
  templateUrl: './raw-alarm-information.component.html',
  styleUrl: './raw-alarm-information.component.scss',
})
export class EventInformationComponent implements OnInit {
  @Input() eventId?: string;
  @Input() commandId?: string;

  @Output() close = new EventEmitter<boolean>();
  alarmGet: AlarmCommandEvent = new AlarmCommandEvent();
  event: AlarmDataOut = new AlarmDataOut();

  alertColors = alertColors;
  getAlertColor = getAlertColor;

  constructor(
    private toastr: ToastrService,
    private client: Client,
  ) { }

  ngOnInit(): void {
    this.getEventById();
  }

  toggleModal() {
    this.event = new AlarmDataOut();
    this.close.emit();
  }

  getEventById() {
    this.alarmGet.command = this.commandId;
    this.alarmGet.event = this.eventId;
    this.client.getAlarm(this.alarmGet).subscribe({
      next: (response) => {
        this.event = response;
      },
      error: (err) => {
        this.toastr.error(err);
        this.close.emit();
      },
    });
  }
}
